import React from 'react'
import { Link } from 'react-router-dom'
import { MainNavigation } from '@manychat/manyui'

import { isPathActive, NavigationRoute } from 'common/core/router'
import { linkURL } from 'utils/url'

import { useNavParams } from './useNavParams'

interface NavItemProps {
  item: NavigationRoute
  index: number
  expanded: boolean
  onClick: (label: string) => void
}

export const NavItem = ({ item, index, expanded, onClick }: NavItemProps) => {
  const navParams = useNavParams()

  // @ts-expect-error Remove function params when migration to new Sidebar is done
  const labelValue = typeof item.label === 'function' ? item.label(navParams, {}) : item.label
  const iconValue = typeof item.icon === 'function' ? item.icon(navParams) : item.icon
  const badgeValue = typeof item.badge === 'function' ? item.badge(navParams) : item.badge
  const isActive = Boolean(item.url) && isPathActive(item.url)
  const href = linkURL(item.url)

  if ('hide' in item && item.hide && item.hide(navParams)) {
    return null
  }

  return (
    <MainNavigation.Item
      as={Link}
      key={index}
      icon={iconValue}
      to={href}
      collapsed={!expanded}
      notificationCount={badgeValue}
      hasNotification={Boolean(badgeValue)}
      tooltip={labelValue}
      ariaLabel={labelValue}
      selected={isActive}
      onClick={() => {
        onClick(labelValue)
      }}
    >
      {labelValue}
    </MainNavigation.Item>
  )
}
